import React, { FC } from 'react';
import { t } from 'i18next';
import { InfoRowProps } from '../types/leaveRequestType';
import { DemandeConge } from 'features/collaborateur/types';
import TruncateText from 'components/common/TruncateText';
import { GetLeaveUsers } from '../services/leaveService';

export const InfoRow: FC<InfoRowProps> = ({
  label,
  value,
  color = 'default',
}) => (
  <div className="row g-0 minthr-flex-items-center minthr-mb-1">
    <div className="col-sm-4">
      <span className="minthr-text-uppercase p">{label}:</span>
    </div>
    <div className="col-sm-8">
      <TruncateText
        maxLines={1}
        className={
          color === 'green'
            ? 'minthr-color-primary minthr-font-weight-600'
            : 'minthr-color-dark h5'
        }
        showExpandButton={true}
        buttonClassName="minthr-expand-long-text minthr-color-primary minthr-text-decoration-underline readMoreLink"
        tag="span"
      >
        {value}
      </TruncateText>
    </div>
  </div>
);

interface StatusRowProps {
  label: string;
  status: string;
}

export const StatusRow: FC<StatusRowProps> = ({ label, status }) => {
  const getStatusClass = (status: string): string => {
    switch (status) {
      case 'Accepter':
        return 'minthr-badge-success';
      case 'En_Cour':
        return 'minthr-badge-warning';
      case 'Annuler':
        return 'minthr-badge-danger';
      case 'Refuser':
        return 'minthr-badge-danger';
      default:
        return '';
    }
  };

  return (
    <div className="row g-0 minthr-flex-items-center minthr-mb-1">
      <div className="col-sm-4">
        <span className="minthr-text-uppercase p">{label}:</span>
      </div>
      <div className="col-sm-8">
        <span
          className={`minthr-badge ${getStatusClass(status)} minthr-badge-s minthr-px-2`}
        >
          {t(`Status.${status}`)}
        </span>
      </div>
    </div>
  );
};

export const statusBody: React.FC<DemandeConge> = (rowData) => {
  const getStatusClass = (status: string): string => {
    switch (status) {
      case 'Accepter':
        return 'minthr-badge-success';
      case 'En_Cour':
        return 'minthr-badge-warning';
      case 'Annuler':
        return 'minthr-badge-secondary-dark';
      case 'Refuser':
        return 'minthr-badge-danger';
      default:
        return 'minthr-badge-secondary-dark';
    }
  };
  return (
    <span
      className={` minthr-badge minthr-badge-s ${getStatusClass(rowData.statut)} minthr-px-3  `}
    >
      {t(`Status.${rowData.statut}`)}
    </span>
  );
};

export const fetchUsers = async (): Promise<
  { label: string; value: string }[] | null | undefined
> => {
  const fetchedUsers = await GetLeaveUsers();
  if (Array.isArray(fetchedUsers)) {
    const transformedUsers = fetchedUsers.map((user) => ({
      value: user.value,
      label: user.text,
    }));

    return transformedUsers;
  }
};
